import { getAgeVerificationUrl } from 'utils/helpers';

import { ENUM_IDENTITY_STATUS } from './profile';


export const MESSAGE_CONFIG = {
  HISTORY_LIMIT: 5,
  MAIN_CHAT: {
    GUEST_LIMIT: 5,
    LOGGED_IN_LIMIT: 20,
  },
  MAX_LENGTH: 90,
};

export const MESSAGE_TYPES = {
  UNVERIFIED: 'unverified',
  GUEST: 'guest',
  GENERAL: 'general',
  GOLD: 'gold',
  GOLD_FREE: 'goldFree',
  GOLD_PROMO: 'goldPromo',
  PERFORMER: 'performer',
  USER_MODERATOR: 'userModerator',
  COACH: 'coach',
  MODERATOR: 'moderator',
  ADMIN: 'admin',
  VERIFIED_ROOM_MODERATOR: 'verifiedRoomModerator',
};

export const MESSAGE_FLAIRS = {
  ROOM_MOD: 'Room mod',
  ADMIN: 'CAM4 Admin',
  COACH: 'Coach',
};

export const NOTIFICATION_TYPE = {
  MESSAGE: 1,
  FAN_ENTERED_ROOM: 2,
  SEND_TIP: 3,
  GIFT: 4,
  GOLD_ENTERED_ROOM: 5,
  JOIN_FANCLUB: 15,
  GAME: 20,
  ID_APPROVED: 23,
  ID_REJECTED: 24,
  GO_PUBLIC: 26,
  MARKETPLACE_PURCHASE: 27,
  MARKETPLACE_BULK_PURCHASE: 28,
  ROOM_PASSWORD_CHANGED: 29,
  LIVE_TOUCH: 'LIVE_TOUCH',
  BOOST_STARTED: 34,
  BOOST_ENDED: 35,
  CAMPAIGN_CTA: 'CAMPAIGN_CTA',
  ROOM_MODERATOR_PRIVILEGES: 'ROOM_MODERATOR_PRIVILEGES',
};

export const ALERT_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
};

export const MESSAGE_ERRORS = {
  ERROR_MESSAGE_LIMIT: 'ERROR_MESSAGE_LIMIT',
  ERROR_INVALID_RECIPIENT: 'ERROR_INVALID_RECIPIENT',
  ERROR_SENDER_BANNED_BY_RECIPIENT: 'ERROR_SENDER_BANNED_BY_RECIPIENT',
  ERROR_FRESH_BASIC_USER: 'ERROR_FRESH_BASIC_USER',
};

export const MAKE_ONBOARDING_ERROR_MESSAGES = (user, translate) => {
  return {
    [ENUM_IDENTITY_STATUS.REJECTED]: [
      {
        hasLink: true,
        text: translate('strings.document.upload.rejected'),
        link: {
          url: getAgeVerificationUrl(user),
          text: translate('newshows.newshows.click.more.info'),
        },
      },
    ],
    [ENUM_IDENTITY_STATUS.NO_IDENTITY]: [
      {
        hasLink: true,
        text: translate('strings.not.finished.onboarding'),
        link: {
          url: getAgeVerificationUrl(user),
          text: translate('payment.payment.get.started'),
        },
      },
    ],
  };
};
